import APIService from "./APIService";

const AUTH_END_POINT = process.env.REACT_APP_ADMIN_API_ENDPOINT + "store-details";

export default {
  getStoreDetails() {
    return APIService.get(AUTH_END_POINT)
  }
}